import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  PropType,
  ref,
  unref,
  watch,
} from "vue";

import {
  useI18n,
} from "@/composables/useI18n";

import VueI18n from "vue-i18n";

import type {
  AppSetting,
  Customer,
} from "@/components/customers/scripts/types";

import {
  isSmallerOrEqualToMaxLength,
} from "@/scripts/Common/validators/defaultValidator";

import {
  maximumHardwareLength,
} from "@/components/customers/scripts/constraints";

import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

import QrCodeDialog from "@/components/QrCodeDialog.vue";

import {
  fetchCustomerAppSettings,
} from "@/components/customers/scripts/customerApiRequests";

import {
  createEmptyAppSettings,
} from "@/components/customers/scripts/appSettingsAction";

import {
  isValidDate,
} from "@/scripts/Validations/Validations";

import {
  formatDate,
} from "@/scripts/Common/helpers/dateHelpers";

import {
  DateFormats,
} from "@/scripts/Common/DateFormats";

import InformationDialog from "@/components/base/InformationDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallationEdit',
  props: {
  label: {
    required: true,
    type: String as PropType<string | VueI18n.TranslateResult>,
  },
  hasNoEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  model: {
    required: true,
    type: Object as PropType<Customer>,
  },
  showAppSettings: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  },
  expanded: {
    required: false,
    type: Array as PropType<number[]>,
    default() {
      return [1]
    }
  },
},
  emits: [
  'onValidChange',
  'onFetchError',
  'update:useEcTerminal',
  'update:hardware',
  'update:isInternetAvailable',
  'update:deploymentDate',
  'update:deploymentTime',
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
} = useI18n();





const valid = ref(true);
const showQrCode = ref(false);
const installationForm = ref();
const qrCodeErrorDialog = ref();

const customerAppSettings = ref<AppSetting[]>([]);
const selectedAppSetting = ref<AppSetting>(createEmptyAppSettings());
const qrCodeData = ref("");

const internalExpand = ref(props.expanded);

const useEcTerminal = computed({
  get() {
    return props.model.useEcTerminal
  },
  set(value: boolean) {
    emits('update:useEcTerminal', value);
  }
})

const hardware = computed({
  get() {
    return props.model.hardware;
  },
  set(value: string | undefined) {
    emits('update:hardware', value);
  }
})

const isInternetAvailable = computed({
  get() {
    return props.model.isInternetAvailable;
  },
  set(value: boolean) {
    emits('update:isInternetAvailable', value);
  }
})

const buildDeploymentDate = (deploymentDate: string | undefined, deploymentTime: string | undefined) => {
  if (!deploymentDate) return null;
  if (!deploymentTime) return deploymentDate

  return `${deploymentDate}T${deploymentTime}`
};

const deploymentDate = computed({
  get() {
    return formatDate(props.model?.deploymentDate, DateFormats.ISO8601_LONG);
  },
  set(value: string | undefined) {
    emits('update:deploymentDate', buildDeploymentDate(value, unref(deploymentTime)));
  }
})

const deploymentTime = computed({
  get() {
    return formatDate(props.model?.deploymentDate, DateFormats.HOUR_MINUTE);
  },
  set(value: string | undefined) {
    emits('update:deploymentDate', buildDeploymentDate(unref(deploymentDate), value));
  }
})

const showDeviceSection = computed(() => {
  return props.showAppSettings
})

const onHandleFetchError = ({error}: {
  error: any
}) => {
  emits('onFetchError', {error})
};

const getAppSettingsForAccountingPartner = async () => {
  if (!props.model?.accountingPartnerId) return;

  const {response, error} = await fetchCustomerAppSettings(props.model.accountingPartnerId);

  if (error || !response) {
    onHandleFetchError({error});
    return;
  }

  customerAppSettings.value = response;
}

const renderQrCode = () => {
  if (!selectedAppSetting) return;
  try {
    qrCodeData.value = JSON.stringify(unref(selectedAppSetting));
    showQrCode.value = true;
  } catch (e) {
    qrCodeErrorDialog.value.Show();
  }
}

const validate = () => installationForm.value.validate();


watch(valid, () => {
  validate();
  emits('onValidChange', unref(valid))
})

watch(() => props.expanded, () => {
  internalExpand.value = props.expanded
})

return { __sfc: true,t, props, emits, valid, showQrCode, installationForm, qrCodeErrorDialog, customerAppSettings, selectedAppSetting, qrCodeData, internalExpand, useEcTerminal, hardware, isInternetAvailable, buildDeploymentDate, deploymentDate, deploymentTime, showDeviceSection, onHandleFetchError, getAppSettingsForAccountingPartner, renderQrCode, validate, isSmallerOrEqualToMaxLength, maximumHardwareLength, FloatingActionButton, QrCodeDialog, isValidDate, InformationDialog }
}

})